import React from 'react';
import t from 'react-translate';

import GradientAiIcon from '../../left-panel/novo-ai/components/shared/gradient-ai-icon';
import useAiRolePlayHelper from '../hooks/use-ai-role-play-helper';

type Props = {
  title: string | undefined;
};

const RolePlayTitle = ({ title }: Props) => {
  const { isMobile } = useAiRolePlayHelper();

  return (
    <>
      <GradientAiIcon icon='gen-ai' size='smallest' className='pr-2 my-auto py-4' />
      <div className={`d-flex my-auto py-4 ${isMobile ? 'flex-column' : ''}`}>
        <p className={`mb-0 text-regular bold ${!isMobile ? 'mr-1' : ''}`}>
          {t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.ROLE_PLAY()}
        </p>
        <p className='mb-0'>{title}</p>
      </div>
    </>
  );
};

export default RolePlayTitle;
